module.exports = __webpack_public_path__ + "img/item-12.ff42ebd1.png";